import { useState } from 'react'

/**
 * Copy-to-clipboard helper that exposes a transient `copied` flag which
 * resets to false after `resetMs` (default 1.5s). Clipboard failures are
 * swallowed and leave `copied` false.
 */
export function useCopy(resetMs = 1500): { copied: boolean; copy: (text: string) => void } {
  const [copied, setCopied] = useState(false)
  const copy = (text: string) => {
    navigator.clipboard.writeText(text).then(
      () => {
        setCopied(true)
        setTimeout(() => setCopied(false), resetMs)
      },
      () => { /* ignore clipboard failures */ },
    )
  }
  return { copied, copy }
}
